import { locationAtom } from "@sunrise/location";
import { atom } from "jotai";

export const pathnameAtom = atom((get) => {
  return get(locationAtom).pathname;
});
